import React, {useEffect, useState} from 'react';
import {EnvConfig} from "../../Shared/Constants/environtmentConstants";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import {ExternalLeadType} from "./type/externalLeadType";
import {SaveExternalLeadUnicContactHook} from "./hook/saveExternalLeadUnicContactHook";


const ContactFormUnic = () => {
    const [formData, setFormData] = useState<ExternalLeadType>({
        name: '',
        email: '',
        phone: '',
        address: '',
        type: '',
    });

    const [step, setStep] = useState<number>(0);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!formData.name || !formData.phone || !formData.email || !formData.address || !formData.type) {
            alert('Por favor completa todos los campos obligatorios.');
            return;
        }

        SaveExternalLeadUnicContactHook(formData)
            .then((response) => {
                if (response.status === 200) {
                    setFormData({name: '', phone: '', email: '', address: '', type: ''});
                    setStep(1);
                } else {
                    alert('Error al enviar el formulario. Intenta nuevamente.');
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                alert('Error al enviar el formulario. Intenta nuevamente.');
            });

    };

    const changeLocationData = (key: string, value: any) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value,
        }));
    }

    const handleFormScreen = () => {
        return (
            <form
                onSubmit={handleSubmit}
                style={{
                    maxWidth: '800px',
                    margin: '0 auto',
                    backgroundColor: '#f0f4f4',
                    padding: '40px',
                    borderRadius: '16px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                }}
            >
                <h2 style={{color: '#1a237e', fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '24px'}}>
                    Formulario de contacto
                </h2>

                <div style={{marginBottom: 20}}>
                    <GooglePlacesAutocomplete
                        apiKey={EnvConfig().google_places_api_key}
                        apiOptions={{
                            region: 'es'
                        }}
                        selectProps={{
                            defaultInputValue: formData.address,
                            placeholder: 'Ej: nombre de la calle, 123, Ciudad',
                            onChange: (e: any) => changeLocationData('address', e.label),
                            instanceId: 'react-select-3-live-region',
                            className: 'selectFormValueCustomStyled',
                            classNames: {
                                control: () => {
                                    return 'selectInputCustomStyled'
                                },
                                menu: () => {
                                    return 'selectMenuCustomStyled';
                                }
                            }
                        }}
                    />
                </div>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: '16px'}}>
                    <input
                        type="text"
                        name="name"
                        placeholder="Nombre completo"
                        value={formData.name}
                        onChange={handleChange}
                        style={inputStyle}
                        required
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="Correo electrónico"
                        value={formData.email}
                        onChange={handleChange}
                        style={inputStyle}
                        required
                    />
                    <input
                        type="text"
                        name="phone"
                        placeholder="Teléfono de contacto"
                        value={formData.phone}
                        onChange={handleChange}
                        style={inputStyle}
                        required
                    />
                    <select
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                        style={selectStyle}
                        required
                    >
                        <option value="">Tipo de alquiler</option>
                        <option value="tourist">Turístico</option>
                        <option value="temporary">Temporal</option>
                    </select>
                </div>

                <button
                    type="submit"
                    style={{
                        marginTop: '24px',
                        padding: '12px 24px',
                        backgroundColor: '#0a0f3d',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '6px',
                        fontWeight: '600',
                        cursor: 'pointer',
                    }}
                >
                    Enviar solicitud
                </button>
            </form>
        );
    }

    const handleSuccessScreen = () => {
        return (
            <div style={{
                maxWidth: '800px',
                margin: '0 auto',
                backgroundColor: '#f0f4f4',
                padding: '40px',
                borderRadius: '16px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
            }}>
                <h2 style={{color: '#1a237e', fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '24px'}}>
                    ¡Gracias por tu interés!
                </h2>
                <p style={{fontSize: '1rem', color: '#555'}}>
                    Hemos recibido tu solicitud y nos pondremos en contacto contigo pronto.
                </p>
            </div>
        );
    }

    const handleSwitchScreen = () => {
        return step === 0 ? handleFormScreen() : handleSuccessScreen();
    }

    const inputStyle: React.CSSProperties = {
        width: isMobile ? '100%' : 'calc(50% - 8px)',
        padding: '12px',
        border: '1px solid #ccc',
        borderRadius: '6px',
        fontSize: '0.95rem',
        backgroundColor: '#fff',
    };

    const selectStyle: React.CSSProperties = {
        width: isMobile ? '100%' : 'calc(50% - 8px)',
        padding: '14px',
        border: '1px solid #ccc',
        borderRadius: '6px',
        fontSize: '0.95rem',
        backgroundColor: '#fff',
    };

    return (
        <section style={{padding: '60px 20px', backgroundColor: '#f5f9f8'}}>
            {handleSwitchScreen()}
        </section>
    );


};



export default ContactFormUnic;